export const PUBLIC_ROUTE = {
  LANDING: '/',
  SIGN_IN: '/login',
  SIGN_UP: '/signup',
  TERM_AND_SERVICE: '/term-of-service',
  HELP: '/help',
  SIGN_UP_WELCOME: '/signup/welcome',
  EMAIL_VERIFY: '/verification',
  ACCEPT_COMPANY_REQUEST: '/accept-company-request',
  DECLINE_COMPANY_REQUEST: '/decline-company-request',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_WELCOME: '/reset-password/welcome',
  VIEW_MEMO: '/view-memo',
  DECLINE_BUSINESS_MEMBERS: '/decline-business-members',
  PAGE_403: '/403',
  PAGE_404: '/404',
  PAGE_500: '/500',
  MAINTENANCE: '/maintenance',
  COMPANY_JOBS: '/c-job',
  CLOSE_ACCOUNT: '/close-account',
  LANDING_PAGE: '/',
  MAIN_PAGE_BOOKING: '/intro-booking',
  GET_HIRE_FAST: '/intro-get-hire-fast',
  PAYMENT_TRACKING: '/intro-payment-tracking',
  STRIPE_LINK: '/stripe-link',
  PAYMENT_INVITE: '/payment-invite',
  CANCELED_PAYMENT_INVITE: '/payment-invite/canceled',
  BUDDI_FEED_POSTS: '/buddi-feed/posts',
  BUDDI_FEED_POST: '/buddi-feed/posts/:id'
};

export const PRIVATE_ROUTER = {
  WALLET: '/wallet',
  JOBS: '/jobs',
  BUDDI_FEED: '/buddi-feed'
};

export const MAIN_PAGE = PRIVATE_ROUTER.WALLET;
